import React, { useEffect } from "react";
import { useState } from "react";
import Footer from "../../../MyComponents/Footer";
import GuestNav from "../../../MyComponents/Navbars/GuestNav";
import Hero2 from "../../../MyComponents/Hero2";
import heroContent from "../HeroContent";
import leftimg from "../../../assets/gameDevLeftImg.png";
import rightimg from "../../../assets/gameDevRightImg.png";
import CourseTimeline from "../../../MyComponents/CourseTimeline";
import Benefits from "../../../MyComponents/Benefits";
import gameDevBenefitsImg1 from "../../../assets/gameDevBenefitsImg1.png";
import gameDevBenefitsImg2 from "../../../assets/gameDevBenefitsImg2.png";
import gameDevBenefitsImg3 from "../../../assets/gameDevBenefitsImg3.png";
import gameDevBenefitsImg4 from "../../../assets/gameDevBenefitsImg4.png";
import gameDevBenefitsImg5 from "../../../assets/gameDevBenefitsImg5.png";
import gameDevBenefitsImg6 from "../../../assets/gameDevBenefitsImg6.png";
import gameDevBenefitsImg7 from "../../../assets/gameDevBenefitsImg7.png";
import gameDevBenefitsImg8 from "../../../assets/gameDevBenefitsImg8.png";
import gameDevBenefitsImg9 from "../../../assets/gameDevBenefitsImg9.png";
import FunActivities from "../../../MyComponents/FunActivities";
import gameDevFunActivitiesImg1 from "../../../assets/gameDevFunActivitiesImg1.png";
import gameDevFunActivitiesImg2 from "../../../assets/gameDevFunActivitiesImg2.png";
import gameDevFunActivitiesImg3 from "../../../assets/gameDevFunActivitiesImg3.png";
import gameDevFunActivitiesImg4 from "../../../assets/gameDevFunActivitiesImg4.png";
import gameDevFunActivitiesImg5 from "../../../assets/gameDevFunActivitiesImg5.png";
import LearningStyle from "../../../MyComponents/LearningStyle";
import Testimonials from "../../../MyComponents/Testimonials";
import FAQs from "../../../MyComponents/FooterPages/newfaq";

const UnityGameDevPortal = () => {
  const gamedevpage = heroContent.unitygamedevpage;

  const beginnerModules = [
    {
      title: "Module 1",
      activities: "10",
      classes: "5",
      description:
        "Unity Basics- Control objects with scripts, variables & operators.",
    },
    {
      title: "Module 2",
      activities: "10",
      classes: "5",
      description:
        "Basics of Game Development- Build keyboard-controlled games using conditions & functions.",
    },
    {
      title: "Module 3",
      activities: "10",
      classes: "5",
      description:
        "Advanced Game Development- Add effects, sound, and create a scrolling runner game.",
    },
  ];

  const benefitsData = [
    {
      title: "Master C# Basics",
      description:
        "Grasp core C# concepts from scratch — no prior coding required.",
      icon: gameDevBenefitsImg1,
    },
    {
      title: "Explore Unity Platform",
      description:
        "Get hands-on with Unity tools and workspace for game creation.",
      icon: gameDevBenefitsImg2,
    },
    {
      title: " Write Game Scripts",
      description:
        "Learn how to code movement, logic, and interactions using C#.",
      icon: gameDevBenefitsImg3,
    },
    {
      title: "Use Variables Effectively",
      description:
        "Understand and apply variables and data types in real projects.",
      icon: gameDevBenefitsImg4,
    },
    {
      title: "Apply Game Logic",
      description:
        "Implement conditions, comparisons, and arithmetic in your game code.",
      icon: gameDevBenefitsImg5,
    },
    {
      title: "Control Game Objects",
      description:
        "Script object movement using keyboard inputs for interactive gameplay.",
      icon: gameDevBenefitsImg6,
    },
    {
      title: "Create Endless Gameplay",
      description:
        "Add repeating backgrounds for immersive, continuous game scenes.",
      icon: gameDevBenefitsImg7,
    },
    {
      title: "Enhance with Audio",
      description:
        "Integrate sound effects and music to boost game engagement.",
      icon: gameDevBenefitsImg8,
    },
    {
      title: "Develop Complete Games",
      description:
        "Combine skills to build, test, and polish your own playable games.",
      icon: gameDevBenefitsImg9,
    },
  ];
  const activitiesData = [
    {
      title: "Catch The Food Game",
      image: gameDevFunActivitiesImg1,
    },
    {
      title: "Runner Game",
      image: gameDevFunActivitiesImg2,
    },
    {
      title: "Car Racing Game",
      image: gameDevFunActivitiesImg3,
    },
    {
      title: "Falling Balls Game",
      image: gameDevFunActivitiesImg4,
    },
    {
      title: "Airplane Game",
      image: gameDevFunActivitiesImg5,
    },
  ];

  return (
    <>
      <GuestNav />
      <Hero2
        titlePart1={gamedevpage.titlePart1}
        titlePart2={gamedevpage.titlePart2}
        description={gamedevpage.description}
        buttonText={gamedevpage.buttonText}
        leftImage={leftimg}
        rightImage={rightimg}
      />
      <CourseTimeline
        title1="Course Structure & Syllabus"
        modules={beginnerModules}
      />
      <Benefits
        title="How Students Can Benefit From Game Development (Unity)"
        benefitsData={benefitsData}
      />
      <FunActivities
        mainTitle="Learn Game Development"
        subTitle="With 30+ Fun Activities"
        activities={activitiesData}
      />
      <LearningStyle />
      <Testimonials />
      <FAQs />
      <Footer />
    </>
  );
};
export default UnityGameDevPortal;
